//========================================================================================
/*
  campusList          [arr]
  disabled,           [bool]
  onChange            [func]
  campusId            [str]
  excludeAllLocales   [bool] - exclude "All Locales" from list
*/
//========================================================================================


import React from 'react';
import { translate } from 'react-i18next';

// Components
import { SelectField } from 'components/Fields';

// Style
import s from './CampusSelect.style';

const renderValueItem = ({ item }) => {
  return (
    <s.ValueItemWrapper>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <path d="M3 0h24v24H3z" />
          <path fill="#A2A4B2" fillRule="nonzero"
            d={`M6 21h2v-2H6v2zm3 3h2v-5H9v5zm4 0h2v-5h-2v5zM3 21h2v-2H3v2zm0 3h2v-2H3v2zm3 
          0h2v-2H6v2zm10 0h2v-2h-2v2zm3-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-3-3h2v-2h-2v2zM6 15h2v-2H6v2zm0 
          3h2v-2H6v2zm-3-3h2v-2H3v2zm0 3h2v-2H3v2zm16-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-3-3h2v-2h-2v2zm0 
          3h2v-2h-2v2zm-3-3h2v-2h-2v2zm0 3h2v-2h-2v2zm-4-3h2v-2H9v2zm4-3h2v-2h-2v2zm-4 0h2v-2H9v2zm0 
          6h2v-2H9v2zm9-8V7H6v3H0v14h2V12h6V9h8v3h6v12h2V10h-6zm-7-6h2v2h2V0h-2v2h-2V0H9v6h2V4z`} />
        </g>
      </svg>

      <p>{item && item.name}</p>
    </s.ValueItemWrapper>
  );
};


const CampusSelect = (props) => {
  const { campusList, disabled, onChange, campusId, excludeAllLocales, t } = props;

  const allAvailableCampuses = {
    name: t('all_available_location'),
    id: null
  };

  const sortList =
    Array.isArray(campusList) && campusList.length
      ? campusList.slice().sort((a, b) => (a.name < b.name ? -1 : 1))
      : null;
  // add all available functionality
  if (
    sortList &&
    !excludeAllLocales &&
    !sortList.find(({ id }) => String(id) === String(allAvailableCampuses.id))
  ) {
    sortList.unshift(allAvailableCampuses);
  }
  // set value
  const value = (
    (Array.isArray(sortList) && campusId && sortList.find(({ id }) => String(id) === String(campusId)))
    || (Array.isArray(sortList) && sortList[0])
  );


  return sortList && sortList.length ? (
    <s.CampusesSelectWrapper
      className="campus-select-wrapper"
      disabled={disabled}
      hideFirstElBorder={excludeAllLocales}
    >
      <SelectField
        className="select-field campus-select"
        data={sortList}
        textField="name"
        valueField="id"
        value={value}
        valueComponent={renderValueItem}
        onChange={onChange}
      />
    </s.CampusesSelectWrapper>
  ) : null;
};

export default translate()(CampusSelect);
